const ftcmarray = [
  {
    "ft": 35,
    "cm": "90 x 150"
  },
  {
    "ft": 4666,
    "cm": "140 x 200"
  },
  {
    "ft": 69,
    "cm": "180 x 275"
  },
  {
    "ft": 810,
    "cm": "245 x 305"
  },
  {
    "ft": 912,
    "cm": "275 x 365"
  },
  {
    "ft": 9312,
    "cm": "280 x 365"
  },
  {
    "ft": 10314,
    "cm": "315 x 425"
  },
  {
    "ft": 10143,
    "cm": "305 x 435"
  },
  {
    "ft": 12183,
    "cm": "365 x 556"
  },
  {
    "ft": 1014,
    "cm": "305 x 425"
  },
  {
    "ft": 1215,
    "cm": "365 x 460"
  },
  {
    "ft": 1218,
    "cm": "365 x 550"
  },
  {
    "ft": 96136,
    "cm": "290 x 410"
  },
  {
    "ft": 913,
    "cm": "275 x 400"
  },
  {
    "ft": 46,
    "cm": "120 x 180"
  },
  {
    "ft": 568,
    "cm": "170 x 245"
  },
  {
    "ft": 88,
    "cm": "245 x 245"
  },
  {
    "ft": 1010,
    "cm": "305 x 305"
  },
  {
    "ft": 1212,
    "cm": "365 x 365"
  },
  {
    "ft": 588,
    "cm": "175 x 245"
  },
  {
    "ft": 58,
    "cm": "150 x 245"
  },
  {
    "ft": 9116,
    "cm": "275 x 350"
  },
  {
    "ft": 98143,
    "cm": "295 x 435"
  },
  {
    "ft": 97141,
    "cm": "290 X 430"
  },
  {
    "ft": 9614,
    "cm": "290 x 425"
  },
  {
    "ft": 93119,
    "cm": "280 x 360"
  },
  {
    "ft": 92125,
    "cm": "280 x 380"
  },
  {
    "ft": 9126,
    "cm": "275 x 380"
  },
  {
    "ft": 9123,
    "cm": "275 x 375"
  },
  {
    "ft": 8611,
    "cm": "260 x 335"
  },
  {
    "ft": 8106,
    "cm": "245 x 320"
  },
  {
    "ft": 8912,
    "cm": "265 x 365"
  },
  {
    "ft": 8612,
    "cm": "260 x 365"
  },
  {
    "ft": 81103,
    "cm": "247 x 315"
  },
  {
    "ft": 81102,
    "cm": "247 x 310"
  },
  {
    "ft": 89,
    "cm": "245 x 275"
  },
  {
    "ft": 812,
    "cm": "245 x 365"
  },
  {
    "ft": 811,
    "cm": "245 x 335"
  },
  {
    "ft": 8105,
    "cm": "245 x 320"
  },
  {
    "ft": 8103,
    "cm": "245 x 315"
  },
  {
    "ft": 7610,
    "cm": "230 x 305"
  },
  {
    "ft": 710,
    "cm": "213 X 305"
  },
  {
    "ft": 7910,
    "cm": "236 x 305"
  },
  {
    "ft": 6696,
    "cm": "200 x 290"
  },
  {
    "ft": 696,
    "cm": "180 x 290"
  },
  {
    "ft": 6610,
    "cm": "200 x 305"
  },
  {
    "ft": 6619,
    "cm": "200 x 580"
  },
  {
    "ft": 66156,
    "cm": "200 x 475"
  },
  {
    "ft": 6615,
    "cm": "200 x 460"
  },
  {
    "ft": 6613,
    "cm": "200 x 400"
  },
  {
    "ft": 68,
    "cm": "180 x 245"
  },
  {
    "ft": 598,
    "cm": "175 x 245"
  },
  {
    "ft": 57,
    "cm": "150 x 215"
  },
  {
    "ft": 5676,
    "cm": "170 x 230"
  },
  {
    "ft": 3612,
    "cm": "110 x 365"
  },
  {
    "ft": 36116,
    "cm": "110 x 350"
  },
  {
    "ft": 346,
    "cm": "90 x 140"
  },
  {
    "ft": 34,
    "cm": "90 x 120"
  },
  {
    "ft": 264,
    "cm": "80 x 140"
  },
  {
    "ft": 23,
    "cm": "60 x 90"
  },
  {
    "ft": 1418,
    "cm": "425 x 550"
  },
  {
    "ft": 12616,
    "cm": "380 x 490"
  },
  {
    "ft": 126146,
    "cm": "380 x 445"
  },
  {
    "ft": 126126,
    "cm": "380 x 380"
  },
  {
     "ft": 2612,
    "cm": "80 x 365" 
  },
  {
    "ft": 122123,
    "cm": "370 x 375"
  },
  {
    "ft": 12182,
    "cm": "365 x 555"
  },
  {
    "ft": 12176,
    "cm": "365 x 535"
  },
  {
    "ft": 1217,
    "cm": "365 x 520"
  },
  {
    "ft": 1219,
    "cm": "365 x 580"
  },
  {
    "ft": 1117,
    "cm": "335 x 520"
  },
  {
    "ft": 116176,
    "cm": "350 x 535"
  },
  {
    "ft": 11617,
    "cm": "350 x 520"
  },
  {
    "ft": 116136,
    "cm": "350 x 410"
  },
  {
    "ft": 1114,
    "cm": "335 x 425"
  },
  {
    "ft": 1016,
    "cm": "305 x 490"
  },
  {
    "ft": 10136,
    "cm": "305 x 410"
  },
  {
    "ft": 1011,
    "cm": "305 x 335"
  },
  {
    "ft": 103142,
    "cm": "312 x 432"
  },
  {
    "ft": 121152,
    "cm": "368 x 462"
  },
  {
    "ft": 101142,
    "cm": "307 x 432"
  },
  {
    "ft": 91122,
    "cm": "276 x 370"
  },
  {
    "ft": 101143,
    "cm": "307 x 435"
  },
  { 
    "ft": 122154, 
    "cm": "370 x 467" 
  },
  { 
    "ft": 1111155, 
    "cm": "363 x 470" 
  },
  { 
    "ft": 122182, 
    "cm": "370 x 554"
  },
  { 
    "ft": 9126, 
    "cm": "274 x 381" 
  },
   { 
    "ft": 9124, 
    "cm": "275 x 375" 
  },
  {
    "ft": "3Dia",
    "cm": "180"
  },
  {
    "ft": "6Dia",
    "cm": "180"
  },
  {
    "ft": "6",
    "cm": "180"
  },
  {
    "ft": "6DIA",
    "cm": "180"
  },
  {
    "ft": "8DIA",
    "cm": "245"
  },
   
  {
    "ft": "8Dia",
    "cm": "245"
  },
  {
    "ft": 86116,
    "cm": "260 x 350"
  },
  {
    "ft": 8116,
    "cm": "245 x 350"
  },
  {
    "ft": 8106,
    "cm": "245 x 320"
  },
  {
    "ft": 7696,
    "cm": "230 x 290"
  },
  {
    "ft": 711,
    "cm": "215 x 335"
  },
  {
    "ft": 6698,
    "cm": "200 x 295"
  },
  {
    "ft": 38,
    "cm": "90 x 245"
  },
  {
    "ft": 268,
    "cm": "80 x 245"
  },
  {
    "ft": 1420,
    "cm": "425 x 610"
  },
  {
    "ft": 1013,
    "cm": "305 x 400"
  },
  {
    "ft": 8686,
    "cm": "260 x 260"
  },
  {
    "ft": 7510,
    "cm": "226 x 305"
  },
  {
    "ft": 719,
    "cm": "217 x 275"
  },
  {
    "ft": 718,
    "cm": "217 x 245"
  },
  {
    "ft": 797,
    "cm": "215 x 290"
  },
  {
    "ft": 77,
    "cm": "215 x 215"
  },
  {
    "ft": 6974,
    "cm": "210 x 225"
  },
  {
    "ft": 6810,
    "cm": "205 x 305"
  },
  {
    "ft": 6666,
    "cm": "200 x 200"
  },
  {
    "ft": 692,
    "cm": "180 x 280"
  },
  {
    "ft": 689,
    "cm": "180 x 265"
  },
  {
    "ft": 667,
    "cm": "180 x 205"
  },
  {
    "ft": 5486,
    "cm": "165 x 260"
  },
  {
    "ft": 828,
    "cm": "250 x 245"
  },
  {
    "ft": 612,
    "cm": "180 x 365"
  },
  {
    "ft": 569,
    "cm": "170 x 275"
  },
  {
    "ft": 567,
    "cm": "170 X 215"
  },
  {
    "ft": 7695,
    "cm": "230 X 290"
  },
  {
    "ft": 67810,
    "cm": "201 X 270"
  },
  {
    "ft": 7194,
    "cm": "216 X 290"
  },
  {
    "ft": 711811,
    "cm": "242 X 272"
  },
  {
    "ft": 6787,
    "cm": "201 X 262"
  },
  {
    "ft": 557,
    "cm": "165 X 215"
  },
  {
     "ft": 57710,
    "cm": "170 x 240" 
  },
  {
    "ft": 5671,
    "cm": "170 X 216"
  },
  {
     "ft": 5679,
    "cm": "170 x 236" 
    },
  {
    "ft": 66,
    "cm": "200"
  },
  {
    "ft": 86,
    "cm": "260"
  },
  {
    "ft": 8,
    "cm": "245"
  },
  {
    "ft": 1164,
    "cm": "335 X 193"
  },
  {
    "ft": 869,
    "cm": "245 X 205"
  },
  {
    "ft": 1085,
    "cm": "305 X 256"
  },
  {
    "ft": 76,
    "cm": "215 X 180"
  },
  {
    "ft": 91068,
    "cm": "300 X 203"
  },
  {
    "ft": 755,
    "cm": "215 X 165"
  },
  {
    "ft": 10156,
    "cm": "305 X 475"
  },
  {
    "ft": 91165,
    "cm": "277 x 500"
  },
  {
    "ft": 5681,
    "cm": "172 x 246"
  },
  {
    "ft": 4975,
    "cm": "146 x 227"
  },
  {
    "ft": 5197,
    "cm": "156 x 293"
  },
  {
    "ft": 28102,
    "cm": "80 x 309"
  },
  {
    "ft": 5293,
    "cm": "156 x 282"
  },
  {
    "ft": 3386,
    "cm": "98 x 258"
  },
  {
    "ft": 41110,
    "cm": "123 x 360"
  },
  {
    "ft": 53128,
    "cm": "160 x 385"
  },
  {
    "ft": 6591,
    "cm": "196 x 276"
  },
  {
    "ft": 5681,
    "cm": "172 x 246"
  },
  {
    "ft": 51112,
    "cm": "180 x 365"
  },
  {
    "ft": 59108,
    "cm": "175 x 325"
  },
  {
    "ft": 5477,
    "cm": "159 x 226"
  },
  {
    "ft": 59111,
    "cm": "176 x 338"
  },
  {
    "ft": 5279,
    "cm": "156 x 235"
  },
  {
    "ft": 6291,
    "cm": "188 x 276"
  },
  {
    "ft": 56910,
    "cm": "169 x 300"
  },
  {
    "ft": 5477,
    "cm": "163 x 231"
  },
  {
    "ft": 6910,
    "cm": "205 x 305"
  },
  {
    "ft": 510101,
    "cm": "179 x 307"
  },
  {
    "ft": 5386,
    "cm": "160 x 260"
  },
  {
    "ft": 76144,
    "cm": "230 x 436"
  },
  {
    "ft": 48132,
    "cm": "143 x 400"
  },
  {
     "ft": 1321,
    "cm": "396 x 640" 
  },
  {
    "ft": 60128,
    "cm": "182 x 385"
  },
  {
    "ft": 102151,
    "cm": "310 x 460"
  },
  {
    "ft": 6395,
    "cm": "190 x 286"
  },
  {
    "ft": 5896,
    "cm": "172 x 290"
  },
  {
    "ft": 411810,
    "cm": "150 x 270"
  },
  {
    "ft": 5982,
    "cm": "176 x 250"
  },
  {
    "ft": 41182,
    "cm": "151 x 247"
  },
  {
    "ft": 410711,
    "cm": "147 x 240"
  },
  {
    "ft": 5466,
    "cm": "162 x 197"
  },
  {
    "ft": 5893,
    "cm": "173 x 283"
  },
  {
    "ft": 5811,
    "cm": "171 x 335"
  },
  {
    "ft": 60810,
    "cm": "182 x 268"
  },
  {
    "ft": 60113,
    "cm": "183 x 344"
  },
  {
     "ft": 130166,
    "cm": "396 x 505" 
  },
  {
    "ft": 79102,
    "cm": "237 x 310"
  },
  {
    "ft": 75114,
    "cm": "226 x 346"
  },
  {
    "ft": 85118,
    "cm": "256 x 355"
  },
  {
    "ft": 761010,
    "cm": "228 x 330"
  },
  {
    "ft": 65910,
    "cm": "195 x 300"
  },
  {
    "ft": 67910,
    "cm": "200 x 300"
  },
  {
    "ft": 6596,
    "cm": "195 x 290"
  },
  {
    "ft": 511106,
    "cm": "180 x 320"
  },
  {
    "ft": 46,
    "cm": "120 x 180"
  },
  {
    "ft": 10146,
    "cm": "305 x 442"
  },
  {
    "ft": 57,
    "cm": "150 x 215"
  },
  {
    "ft": 1319,
    "cm": "245 x 315"
  },
    {
    "ft": 11615,
    "cm": "400 x 580"
  },
  {
    "ft": 2610,
    "cm": "76 x 305"
  },
  {
    "ft": 418,
    "cm": "80 x 305"
  },
  {
    "ft": 26223,
    "cm": "80 x 680"
  },
  {
    "ft": 2614,
    "cm": "120 x 550"
  },
  {
    "ft": 2620,
    "cm": "80 x 425"
  },
  {
    "ft": 316,
    "cm": "80 x 610"
  },
  {
    "ft": 26156,
    "cm": "80 x 475"
  },
  {
    "ft": 2618,
    "cm": "80 x 550"
  },
  {
    "ft": 2624,
    "cm": "80 x 732"
  },
  {
    "ft": 610,
    "cm": "183 x 305"
    },
    {
    "ft": 896,
    "cm": "244 x 290"
    },
    {
    "ft": 1020,
    "cm": "305 x 610"
    },
    {
    "ft": 1313,
    "cm": "396 x 396"
    },
    {
    "ft": 2622,
    "cm": "76 x 671"
    },
    {
    "ft": 2683,
    "cm": "76 x 251"
    },
    {
    "ft": 5881,
    "cm": "173 x 246"
    },
    {
    "ft": 6113,
    "cm": "183 x 343"
    },
    {
    "ft": 6128,
    "cm": "183 x 386"
    },
    {
    "ft": 8113,
    "cm": "244 x 343"
    },
    {
    "ft": 8310,
    "cm": "251 x 305"
    },
    {
    "ft": 9613,
    "cm": "290 x 396"
    },
    {
    "ft": 11156,
    "cm": "335 x 472"
    },
    {
    "ft": 11166,
    "cm": "335 x 503"
    },
    {
    "ft": 111618,
    "cm": "351 x 549"
    },
    {
    "ft": 12153,
    "cm": "366 x 465"
    },
    {
    "ft": 12156,
    "cm": "366 x 472"
    },
    {
    "ft": 12620,
    "cm": "381 x 610"
    },
    {
    "ft": 666106,
    "cm": "198 x 320"
    },
    {
    "ft": 83103,
    "cm": "251 x 312"
    },
    {
    "ft": 93123,
    "cm": "282 x 373"
    },
    {
    "ft": 93126,
    "cm": "280 x 380"
    },
    {
    "ft": 96186,
    "cm": "290 x 564"
    },
    {
    "ft": 111614,
    "cm": "351 x 442"
    },
    {
    "ft": 531111,
    "cm": "160 x 363"
    },
    {
    "ft": 53111,
    "cm": "160 x 363"
    },
    {
     "ft": 12115,
    "cm": "368 x 457" 
    },
    {
     "ft": 92121,
    "cm": "280 x 368" 
    },
    {
     "ft": 61010,
     "cm": "209 x 305" 
    },
    {
     "ft": 75104,
    "cm": "225 x 316" 
    },
    {
     "ft": 16324,
    "cm": "495 x 732" 
    },
    {
    "ft": "66DIA",
    "cm": "201 Dia"
    },
    {
    "ft": "78DIA",
    "cm": "238"
    },
    {
    "ft": "86DIA",
    "cm": "262"
    },
    {
     "ft": "61110",
    "cm": "210 x 305" 
    },
    {
     "ft": "61210",
    "cm": "210 x 305" 
    },
    {
     "ft": "78117",
    "cm": "235 x 353" 
    },
    {
     "ft": "8286",
    "cm": "248 × 259" 
    },
    {
     "ft": "68911",
    "cm": "202 × 301" 
    },
    {
     "ft": "710911",
    "cm": "240 × 302" 
    },
    {
     "ft": "10214",
    "cm": "310 × 425" 
    },
    {
     "ft": "122184",
    "cm": "370 × 560" 
    },
    {
     "ft": "82102",
    "cm": "250 × 310" 
    },
    {
     "ft": "82911",
    "cm": "250 × 302" 
    },
    {
     "ft": "82104",
    "cm": "250 × 315" 
    },
    {
     "ft": "811122",
    "cm": "272 × 370" 
    },
]